import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { $http, $request } from './utils/http'
import Common from './utils/common'

import './assets/scss/common.scss'

const app = createApp(App)
app.config.globalProperties.$http = $http
app.config.globalProperties.$request = $request
app.config.globalProperties.$common = Common

if (process.env.NODE_ENV == 'development') {
    app.config.globalProperties.devtools = true
} else {
    app.config.globalProperties.devtools = false
}

app.use(store).use(router).mount('#app')
